import { downloadDataUrl } from "..";

export function downloadCSV(filename: string, csv: string) {
  const base64 = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);

  downloadDataUrl(filename, base64);
}
